import { ReviewArtworkContextPanelGroup } from "./ReviewArtworkContextColumns";

interface CampaignReviewPaneProps {
  /** The review ticket to display (artwork + AI comments + context). */
  ticketId: string;
  /** Close the review screen and return to the default project view. */
  onClose: () => void;
}

/**
 * The project review screen: artwork in the center with comments docked below
 * the asset, and context/reference documents in a dedicated right column.
 *
 * Selection state (active comment + citation highlight) mirrors
 * `TicketViewPane`, but the layout is intentionally different: the project
 * workspace keeps the feed/chat visible on the left, so this pane owns the
 * artwork + comments stack and the context viewer.
 */
export function CampaignReviewPane({
  ticketId,
  onClose,
}: CampaignReviewPaneProps) {
  return (
    <ReviewArtworkContextPanelGroup ticketId={ticketId} onClose={onClose} />
  );
}
